(function () {
  // Function to get the last collection URL from localStorage
  function getLastCollectionURL() {
    const collectionData = localStorage.getItem("collection-page-data");
    if (collectionData) {
      const parsedData = JSON.parse(collectionData);
      return parsedData.url || null;
    }
    return null;
  }

  // Function to update the href for the previous page
  function getPreviousPageURL() {
    return document.referrer || null; // Fallback to `null` if no referrer
  }

  // Main logic to process links with the `phs` class
  function processLinks() {
    const links = document.querySelectorAll("a.phs");

    links.forEach((link) => {
      if (link.classList.contains("previous-collection")) {
        const lastCollectionURL = getLastCollectionURL();
        if (lastCollectionURL) {
          link.href = lastCollectionURL; // Update href to the last collection URL
        } else {
          console.warn("No previous collection URL found in localStorage.");
        }
      } else if (link.classList.contains("previous-url")) {
        const previousPageURL = getPreviousPageURL();
        if (previousPageURL) {
          link.href = previousPageURL; // Update href to the previous page URL
        } else {
          console.warn("No previous page URL found in the history state.");
        }
      }
    });
  }

  // Run the function on page load
  document.addEventListener("DOMContentLoaded", processLinks);
})();
